import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import "./ConfirmDeleteDialog.css";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => any;
  title?: string;
  message?: string;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Deletion",
  message = "Are you sure you want to delete the selected template(s)?",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      classes={{ paper: "custom-dialog" }}
    >
      <DialogTitle id="confirm-dialog-title" className="custom-dialog-title">
        <InfoIcon fontSize="small" />
        {title}
        <CloseIcon className="custom-close-icon" onClick={onClose} />
      </DialogTitle>
      <DialogContent className="custom-dialog-content">
        <DialogContentText
          id="confirm-dialog-description"
          className="custom-dialog-text"
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="custom-dialog-actions">
        <Button onClick={onClose} className="custom-cancel-button" variant="contained">
          Cancel
        </Button>
        <Button onClick={onConfirm} className="custom-delete-button" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
